module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6254575e75d05fe637cc61b7197c2123.png";